<template>
    <div class="mb-5">
        <Requests v-if="$route.name === 'admin-requests'"/>
        <Campaigns v-if="$route.name === 'admin-campaigns'"/>
        <Drafts v-if="$route.name === 'admin-drafts'"/>
        <Archives v-if="$route.name === 'admin-archives'"/>
        <Referrals v-if="$route.name === 'admin-referrals'"/>
    </div>
</template>

<script>
import Drafts from './Drafts'
import Campaigns from './Campaigns'
import Requests from './Requests'
import Archives from './Archives'
import Referrals from './Referrals'
export default {
    name: 'Admin',
    components: {
        Drafts,
        Campaigns,
        Requests,
        Archives,
        Referrals
    },
}
</script>

<style>

</style>